export function groupUsers(users, companiesMap) {
  const groups = new Map();
  users.forEach((user) => {
    const email = user.email ? user.email.toLowerCase().trim() : null;
    const key = email || user.uuid;
    if (!groups.has(key)) groups.set(key, []);
    groups.get(key).push(user);
  });

  return Array.from(groups.values()).map((group) => {
    const primaryName = {
      firstName: group[0].firstName,
      lastName: group[0].lastName,
    };
    const alsoKnownAs = group
      .slice(1)
      .filter(
        (u) =>
          u.firstName !== primaryName.firstName ||
          u.lastName !== primaryName.lastName
      )
      .map((u) => ({ firstName: u.firstName, lastName: u.lastName }));

    const companyUuids = group.map((u) => u.company_uuid).filter(Boolean);
    const companyNames = companyUuids.map(
      (uuid) => companiesMap[uuid] || uuid.slice(0, 8) + "\u2026"
    );

    return {
      ...group[0],
      uuids: group.map((u) => u.uuid),
      companyUuids,
      companyNames,
      alsoKnownAs,
    };
  });
}
